import api from '@/utils/ky';

interface TTSOptions {
  text: string;
  voice_id?: string;
  model_id?: string;
}

export async function playTTS(options: TTSOptions): Promise<void> {
  const { text, voice_id = "tpFVjZdYBvOaWaUIRHRz", model_id = "eleven_turbo_v2_5" } = options;

  try {
    const audioBlob = await api.post('api/elevenlabs/tts', {
      json: {
        text,
        voice_id,
        model_id
      }
    }).blob();

    const audio = new Audio(URL.createObjectURL(audioBlob));

    return new Promise((resolve, reject) => {
      audio.onended = () => resolve();
      audio.onerror = () => reject(new Error('Audio playback failed'));
      audio.play().catch(reject);
    });
  } catch (error) {
    console.error('TTS Error:', error);
    throw error;
  }
}

export async function playScriptFirstMessage(
  message: string,
  voiceId: string
): Promise<void> {
  return playTTS({
    text: message,
    voice_id: voiceId
  });
}

